var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41131 9.15905C3.87401 9.15905 3.4375 8.72254 3.4375 8.18524C3.4375 7.64952 3.87401 7.21302 4.41131 7.21302C4.94861 7.21302 5.38512 7.64952 5.38512 8.18524C5.38512 8.72254 4.94861 9.15905 4.41131 9.15905ZM8.19702 9.15905C7.65972 9.15905 7.22321 8.72254 7.22321 8.18524C7.22321 7.64952 7.65972 7.21302 8.19702 7.21302C8.73433 7.21302 9.17083 7.64952 9.17083 8.18524C9.17083 8.72254 8.73433 9.15905 8.19702 9.15905ZM11.009 8.18524C11.009 8.72254 11.4455 9.15905 11.9828 9.15905C12.5201 9.15905 12.9566 8.72254 12.9566 8.18524C12.9566 7.64952 12.5201 7.21302 11.9828 7.21302C11.4455 7.21302 11.009 7.64952 11.009 8.18524Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68658 14.0733L1.26104 14.4966L1.73099 12.9231C1.86366 12.5342 1.85132 12.0843 1.62274 11.6991C0.980888 10.514 0.625 9.23493 0.625 8.01218C0.625 4.12045 3.73457 0.625164 8.016 0.625164C12.2002 0.625164 15.375 4.05533 15.375 7.98815C15.375 12.5389 11.6723 15.3752 8 15.3752C6.78959 15.3752 5.44713 15.047 4.38543 14.4226C3.99308 14.183 3.42022 13.8372 2.68658 14.0733Z",
    stroke: "white",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.ae9c2808d5cdacd9144bc05da748a9ce.svg";
export { ForwardRef as ReactComponent };